import React, { useEffect } from 'react';
import MainLayout from '../components/layout/MainLayout';
import ScrollReveal from '../components/ScrollReveal';
import SEOMetaTags from '../components/SEOMetaTags';

import NexusHero from '../components/home/NexusHero';

import ClientLogos from '../components/clients/ClientLogos';
import HowItWorks from '../components/home/HowItWorks';
import EmpresasGrid from '../components/home/EmpresasGrid';
import ResultsSocialProof from '../components/home/ResultsSocialProof';
import WhyNexus from '../components/home/WhyNexus';
import PartnersSection from '../components/clients/PartnersSection';
import ATSIntegrationsSection from '../components/clients/ATSIntegrationsSection';
import CorporateFAQSection from '../components/home/CorporateFAQSection';
import FinalCTA from '../components/home/FinalCTA';

import { scrollToSection } from '@/utils/scrollUtils';

const Index = () => {
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      setTimeout(() => {
        scrollToSection(hash);
      }, 100);
    }
  }, []);

  return (
    <MainLayout>
      <SEOMetaTags />

      {/* 1. Hero */}
      <NexusHero />

      {/* 3. Client Logos */}
      <section className="bg-white" style={{ paddingTop: "80px", paddingBottom: "80px" }}>
        <div className="container mx-auto px-4 md:px-6">
          <p className="text-center text-[13px] uppercase tracking-wider text-muted-foreground mb-8">
            Confían en nosotros
          </p>
          <ClientLogos />
        </div>
      </section>

      {/* 4. How it works */}
      <ScrollReveal delay={100}>
        <HowItWorks />
      </ScrollReveal>

      {/* 5. Solutions */}
      <ScrollReveal delay={100}>
        <EmpresasGrid />
      </ScrollReveal>

      {/* 6. Results & social proof */}
      <ScrollReveal delay={100}>
        <ResultsSocialProof />
      </ScrollReveal>

      {/* 7. Why Nexus */}
      <ScrollReveal delay={100}>
        <WhyNexus />
      </ScrollReveal>

      {/* 8. Partners + integrations */}
      <ScrollReveal delay={100}>
        <section id="partners" className="bg-white" style={{ paddingTop: "80px", paddingBottom: "80px" }}>
          <div className="container mx-auto px-4 md:px-6">
            <PartnersSection />
            <ATSIntegrationsSection />
          </div>
        </section>
      </ScrollReveal>

      {/* 9. FAQ */}
      <ScrollReveal delay={100}>
        <CorporateFAQSection />
      </ScrollReveal>

      {/* 10. Final CTA */}
      <FinalCTA />


    </MainLayout>
  );
};

export default Index;
